import { useState } from 'react';
import { bekannteListe, anmelden, abmelden, spaeter, aktueller } from '../services/mitarbeiter';

/**
 * 👷 Schichtbeginn: Name antippen → 4-stellige PIN → angemeldet (das Gerät merkt sich den Mitarbeiter).
 * „Später" überspringt für diese Sitzung (dann wird nichts zugeordnet); „Schicht beenden" meldet ab.
 */
export default function MitarbeiterAnmeldung({ t, colors, onClose }) {
  const liste = bekannteListe();
  const jetzt = aktueller();
  const [wahl, setWahl] = useState(null); // {id, name}
  const [pin, setPin] = useState('');
  const [fehler, setFehler] = useState('');
  const [busy, setBusy] = useState(false);
  const dark = colors?.darkMode;
  const farbe = { text: dark ? '#fff' : '#23272f', sub: dark ? '#aaa' : '#666', rand: dark ? '#444' : '#ddd', feld: dark ? '#1b1f27' : '#fff' };

  const pruefen = async (p) => {
    if (!wahl || !/^\d{4}$/.test(p)) return;
    setBusy(true); setFehler('');
    try {
      await anmelden(wahl.id, p);
      onClose(true);
    } catch (e) {
      setFehler(e && e.status === 403 ? t('staffs.pinWrong') : e && e.status === 429 ? t('staffs.locked') : t('staffs.offline'));
      setPin('');
    }
    setBusy(false);
  };

  const knopf = (primary) => ({
    width: '100%', padding: '12px', borderRadius: 10, marginTop: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer',
    border: primary ? 'none' : `1px solid ${farbe.rand}`, background: primary ? '#1976d2' : 'transparent', color: primary ? '#fff' : farbe.text,
  });

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 7650, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div data-testid="staffs-login" style={{ background: dark ? '#23272f' : '#fff', color: farbe.text, borderRadius: 14, width: '100%', maxWidth: 420,
        maxHeight: '90vh', overflowY: 'auto', padding: 18, boxShadow: '0 10px 40px rgba(0,0,0,0.4)' }}>
        <strong style={{ fontSize: 17 }}>👷 {wahl ? wahl.name : t('staffs.loginTitle')}</strong>
        <div style={{ fontSize: 13, color: farbe.sub, marginTop: 6, lineHeight: 1.5 }}>
          {wahl ? t('staffs.enterPin') : t('staffs.loginExplain')}
        </div>

        {!wahl && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', gap: 8, marginTop: 12 }}>
            {liste.map((m) => (
              <button key={m.id} type="button" data-testid="staffs-login-name" onClick={() => { setWahl(m); setPin(''); setFehler(''); }}
                style={{ padding: '14px 8px', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer', wordBreak: 'break-word',
                  border: `2px solid ${jetzt && jetzt.id === m.id ? '#1976d2' : farbe.rand}`, background: farbe.feld, color: farbe.text }}>
                {m.name}
              </button>
            ))}
          </div>
        )}

        {wahl && (
          <>
            <input data-testid="staffs-login-pin" type="password" inputMode="numeric" autoComplete="off" maxLength={4} autoFocus value={pin} disabled={busy}
              onChange={(e) => { const p = e.target.value.replace(/\D/g, '').slice(0, 4); setPin(p); if (p.length === 4) pruefen(p); }}
              onKeyDown={(e) => { if (e.key === 'Enter') pruefen(pin); }}
              placeholder="••••"
              style={{ width: '100%', padding: 14, fontSize: 26, letterSpacing: '0.5em', textAlign: 'center', borderRadius: 10, marginTop: 12,
                border: `2px solid ${farbe.rand}`, boxSizing: 'border-box', background: farbe.feld, color: farbe.text }} />
            {fehler && <div data-testid="staffs-login-error" style={{ color: '#e5484d', fontSize: 13, marginTop: 8 }}>⚠️ {fehler}</div>}
            <button type="button" style={knopf(false)} onClick={() => { setWahl(null); setPin(''); setFehler(''); }}>← {t('staffs.otherName')}</button>
          </>
        )}

        {!wahl && jetzt && (
          <button type="button" data-testid="staffs-logout" style={knopf(false)} onClick={() => { abmelden(); onClose(false); }}>
            {t('staffs.endShift', { name: jetzt.name })}
          </button>
        )}
        {!wahl && !jetzt && (
          <button type="button" data-testid="staffs-later" style={knopf(false)} onClick={() => { spaeter(); onClose(false); }}>{t('staffs.later')}</button>
        )}
        {!wahl && jetzt && (
          <button type="button" style={knopf(false)} onClick={() => onClose(false)}>{t('common.cancel')}</button>
        )}
      </div>
    </div>
  );
}
